import { makeFilters } from '../filters';
import { TABLE } from '../../../constants/chartTypes';
import { buildDrilldownReport } from '../report';
import { getReportChartType } from '../../../report/reportGetters';
const simpleDrilldown = (report, keys, options) => {
  return makeFilters(report.get('config'), keys, options).then(filters => report.get('config').merge({
    limit: 5,
    filters
  })).then(config => buildDrilldownReport(report, config, options));
};
export default {
  isSupported: report => getReportChartType(report) !== TABLE,
  generate: simpleDrilldown
};